/* eslint-disable no-new */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import EdocLibrary from 'edoc-library';
// import { HTTP_CAMPAIGNS } from '@/http';
import auth from '@/utils/auth';
import App from './App';
import i18n from './i18n';
import store from './store';
import router from './router';
import directives from './directives';

Vue.use(EdocLibrary);

require('edoc-library/dist/css/edoc-library.css');
require('./assets/scss/main.scss');

store.dispatch('auth/check')
  .then(() => {
    if (auth.isLoggedIn() && !auth.getSessionUserNeedFinalization()) {
      store.dispatch('organizations/getOrgConf', auth.getOrgId())
        .then((data) => {
          if (data.extraOptions.specificCSSUrl) {
            const linkExternalStyle = document.createElement('link');
            linkExternalStyle.type = 'text/css';
            linkExternalStyle.rel = 'stylesheet';
            linkExternalStyle.href = data.extraOptions.specificCSSUrl;
            document.getElementsByTagName('head')[0].appendChild(linkExternalStyle);
          }
        });
    }
  });

sync(store, router);

Vue.config.productionTip = false;

const app = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  directives,
  render: h => h(App),
});

export default { app, router, store, i18n, sync };



// WEBPACK FOOTER //
// ./src/main.js